import { useState, useEffect } from 'react'
// component
import { Search, Button } from 'carbon-components-react'
// import cogoToast from 'cogo-toast'
import { toaster } from '../../helpers/toaster'
import UsersGrid from './UsersGrid'
import UserDetailModal from './UserDetailModal'
import ConfirmModal from '../../components/Modal/ConfirmModal'
// api
import {
  addUser,
  updateUser,
  deleteUser,
} from '../../api/users'

const useUsersGrid = ({
  isStudyDetail,
  studyUser,
  setStudyDetails,
} = {}) => {
  // const [userList, setUserList] = useState([])
  const [userData, setUserData] = useState(null)
  const [refreshData, setRefreshData] = useState(false)
  const [userId, setUserId] = useState(null)
  const [userLoading, setUserLoading] = useState(false)
  const [search, setSearch] = useState("")
  const [searchGrid, setSearchGrid] = useState("")
  const [sort, setSort] = useState("")
  const [deleteItemId, setDeleteItemId] = useState(null)
  // modals
  const [openDeleteModal, setOpenDeleteModal] = useState(false)
  const [openUserModal, setOpenUserModal] = useState(false)
  const [detailModalMode, setDetailModalMode] = useState(false)

  const addBtnStyle = {
    padding: "5px 10px",
    height: "30px",
    minHeight: "30px"
  }

  useEffect(() => {
    const timeout = setTimeout(() => {
      setSearchGrid(search)
    }, 500)
    // if this effect run again, because `value` changed, we remove the previous timeout
    return () => clearTimeout(timeout)
  }, [search])

  /** EVENT HANDLERS */

  const openCreateUserModal = () => {
    setDetailModalMode("create")
    setUserData(null)
    setOpenUserModal(true)
  }

  const userRowClicked = (data) => {
    setDetailModalMode("update")
    setUserId(data.id)
    setUserData(data)
    setOpenUserModal(true)
  }

  const showDeleteConfirm = (itemId) => {
    setOpenDeleteModal(true)
    setDeleteItemId(itemId)
  }

  const confirmSave = (regInfo) => {
    setUserLoading(true);
    return addUser(regInfo).then(res => {

      // for grid on study details page
      if (isStudyDetail && studyUser && res.data) {
        setStudyDetails({
          type: 'ADD_ITEM',
          itemType: 'study_users',
          item: res.data,
        })
      }

      // for users list page
      setRefreshData(true)
      toaster("User created successfully", "success")
      setUserLoading(false);
      setOpenUserModal(false)
      return res.data
    }).catch(error => {
      toaster("Failed to create user", "error")
      setUserLoading(false);
      setOpenUserModal(false)
    });

  }

  const confirmUpdate = (userIndex, userInfo) => {
    setUserLoading(true);
    return updateUser(userIndex, userInfo).then(res => {

      // for grid on study details page
      if (isStudyDetail && studyUser && res.data) {
        setStudyDetails({
          type: 'UPDATE_ITEM',
          itemType: 'study_users',
          item: res.data,
        })
      }

      // for users list page
      setRefreshData(true)

      toaster("User updated successfully", "success")
      setUserLoading(false);
      setOpenUserModal(false)
      return res.data
    }).catch(error => {
      toaster("Failed to update user", "error")
      setUserLoading(false);
      setOpenUserModal(false)
    });

  }

  const confirmDelete = () => {
    setUserLoading(true)
    deleteUser(deleteItemId).then(res => {
      // for grid on study details page
      if (studyUser && setStudyDetails) {
        setStudyDetails({
          type: 'DELETE_ITEM',
          itemType: 'study_users',
          id: deleteItemId,
        })
      }

      // for users list page
      setRefreshData(true)

      setUserLoading(false)
      toaster("User deleted successfully", "success")
      setOpenDeleteModal(false)
    })
  }

  /** COMPONENTS */


  const addUserButton = () => {
    return <Button
      kind="primary"
      onClick={() => openCreateUserModal()}
      style={addBtnStyle}
    >Add User
    </Button>
  }

  const userSearch = () => {
    return <div style={{ width: "300px" }}>
      <Search
        size="sm"
        value={search}
        labelText="search"
        onChange={e => setSearch(e.target.value)}
        placeHolderText="Search using any data value" />
    </div>
  }


  const usersGrid = () => {
    return <>
      <UsersGrid
        usersList={studyUser}
        onRowClicked={userRowClicked}
        search={searchGrid}
        onDeleteClicked={showDeleteConfirm}
        setRefresh={setRefreshData}
        refresh={refreshData}
        sort={sort}
        setSort={setSort}
        isStudyDetail={isStudyDetail}
      />
      <UserDetailModal
        mode={detailModalMode}
        userIndex={userId}
        open={openUserModal}
        userData={userData}
        onClose={() => setOpenUserModal(false)}
        confirmSave={confirmSave}
        confirmUpdate={confirmUpdate}
        setUserLoading={setUserLoading}
      />
      <ConfirmModal
        title="Confirmation"
        content="Are you sure you want to delete this user?"
        open={openDeleteModal}
        onClose={() => setOpenDeleteModal(false)}
        onConfirm={() => confirmDelete()}
      />
    </>
  }

  return {
    addUserButton,
    userSearch,
    usersGrid,
    userLoading,
    setUserLoading,
  }
}

export default useUsersGrid